import { Button } from '@app/components/various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '@app/components/various/Dropdown';
import { MoreVerticallySmall } from '@app/components/various/Icons';
import { useOrderListOptions } from '@app/utils/hooks/order/useOrderListOptions';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  order: Order.Essentials;
  onDelete?: (order: Order.Essentials) => void;
  onCopyToNewSelection: (order: Order.Essentials) => void;
  onLinesheetDownload: (order: Order.Essentials) => void;
}

export const OrderActionsColumn = ({ order, onDelete, onCopyToNewSelection, onLinesheetDownload }: Props) => {
  const { t } = useTranslation(['orders']);

  const dropdownItems = useOrderListOptions({
    onCopyToNewSelection,
    onDelete,
    onLinesheetDownload,
    order,
  });

  return (
    <Dropdown title={t('orders:order_options')} placement="bottom-end">
      <DropdownTrigger>
        <Button
          className="-mx-3 size-10 flex-1"
          variant="text"
          color="secondary"
          icon={MoreVerticallySmall}
          aria-label={t('orders:order_options')}
        />
      </DropdownTrigger>
      <DropdownMenu items={dropdownItems} />
    </Dropdown>
  );
};
